module.exports = __webpack_public_path__ + "img/adaptive-learning.ba0d7fee.svg";